import {
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR, GET_STORES, DELETE_STORE, DELETE_STORE_SUCCESS,
} from "./actionType";
import {DELETE_PRODUCT_FAIL, DELETE_PRODUCT_SUCCESS} from "../product/actionType";

const INIT_STATE = {
  stores: [],
  error: {},
};

const Product = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_STORES:
          console.log(action.payload.data.store);
          return {
            ...state,
            stores: action.payload.data.store,
          };

        case DELETE_STORE:
          return {
            ...state,
            stores: state.stores.filter(
              store => (store.id + '') !== (action.payload.data + '')
            ),
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_STORES:
          return {
            ...state,
            error: action.payload.error,
          };

        case DELETE_STORE:
          return {
            ...state,
            error: action.payload.error,
          };
        default:
          return { ...state };
      }

    case GET_STORES:
      return {
        ...state,
      };
    case DELETE_STORE:
      return {
        ...state,
      };

    case DELETE_STORE_SUCCESS:
      return {
        ...state,
        products: state.products.filter(
          product => product.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PRODUCT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return { ...state };
  }
};

export default Product;
